module.exports = __webpack_public_path__ + "static/media/GOSEO.468b4d6a.svg";